<vi-page *ngIf="installationsStore.state$ | async as state" [sidenavs]="true" [footer]="true">
  <app-commercial-toolbar head></app-commercial-toolbar>
  <app-downtime-notification head></app-downtime-notification>
  <app-callback-notification head></app-callback-notification>
  <vi-progress-bar head [isLoading]="state.loading"></vi-progress-bar>

  <vi-content [class.full-width-table]="!isTableDesktopView" [contentWidth]="contentWidth" body>
    <app-status-page
      [class.empty-status-page]="!(statusPageStore.shouldMaintenanceBannerBeDisplayed$ | async)"
      main
      class="full-width"
    ></app-status-page>

    <ng-container main *ngIf="authStore.userHasAccessToInvitations() | async">
      <vi-message
        main
        data-at-message
        *ngIf="dataService.invitationsCount$ | async as invitationsCount"
        gtm="onGoToPage"
        gtmAction="Invitations"
        gtmCategory="notification"
        type="info"
        [clickable]="true"
        [routerLink]="['/invitations']"
      >
        <mat-icon>mail_outline</mat-icon>
        <vi-text content="{{ invitationsCount | translateIncomingCount }}"> </vi-text>
      </vi-message>
    </ng-container>

    <ng-container main *ngIf="state.loading; else showData">
      <vi-loader
        data-at-loader
        [isLoading]="true"
        [message]="'+INSTALLATIONS.INSTALLATIONS.LOADING_MESSAGE' | translate"
      ></vi-loader>
    </ng-container>

    <ng-template main #showData>
      <ng-container *ngIf="state.isData; else noData">
        <app-installation-dashboard
          data-at-dashboard
          [companyName]="authStore.companyName$ | async"
        >
        </app-installation-dashboard>

        <app-installation-filter
          data-at-filter
          [activeFilter]="param?.filter"
          [installationsAmount]="installationsService.sourcedInstallations.length"
          [errorsAmount]="installationsService.errorsAmount"
          [offlineAmount]="installationsService.offlineAmount"
          [maintenanceAmount]="installationsService.maintenanceAmount"
          [remoteDiagnosticAmount]="installationsService.remoteDiagnosticAmount"
          [coldSystemAmount]="installationsService.coldSystemAmount"
          [workingAmount]="installationsService.workingAmount"
          (filter)="filter($event)"
        >
        </app-installation-filter>

        <app-installation-list
          data-at-installatios-list
          #listComp
          [ngClass.lt-lg]="{ 'no-filters-xs': !areProcessedInstallations() }"
          matSort
          [matSortActive]="param.sortBy"
          [matSortDirection]="param.orderBy"
          (matSortChange)="sort($event)"
        >
          <app-installation-search
            search
            #searchComp
            [searchTerm]="param.search"
            (search)="search($event)"
            (clear)="clearSearch()"
          ></app-installation-search>
          <app-limited-search
            limited
            data-at-search
            *ngIf="activeSearch && areProcessedInstallations()"
            class="flex-[150px] lt-lg:order-4"
            [noResults]="false"
            [isLimited]="installationsService.isSearchingLimited"
          ></app-limited-search>

          <div
            sort
            data-at-sort
            *ngFor="let sorter of sorters"
            #sortHeaders
            class="sort"
            [mat-sort-header]="sorter.name"
            [disabled]="!sorter.enabled"
            [ngStyle]="{ 'max-width': sorter.flex, 'min-width': sorter.flex, flex: sorter.flex }"
          >
            {{ sorter.label | translate }}
          </div>
          <ng-container
            installation-item
            *ngFor="let installation of installations$ | async; trackBy: installationTrackBy"
          >
            <app-installation-item
              installation-item
              data-at-installation
              id="installation-{{ installation.id }}"
              [installation]="installation"
              [sortActive]="param.sortBy"
              [isTableDesktopView]="isTableDesktopView"
              [class.selected]="dataService.selectedInstallationId === installation.id"
              [isFlatRate]="remoteConfigStore.isFlatRate$ | async"
            >
            </app-installation-item>
          </ng-container>

          <app-limited-search
            no-results
            data-at-search-no-results
            *ngIf="!areProcessedInstallations()"
            class="flex-[250px]"
            [noResults]="true"
            [isLimited]="installationsService.isSearchingLimited"
            >{{ param.search }}</app-limited-search
          >
          <mat-paginator
            data-at-paginator
            paginator
            *ngIf="isPaginator()"
            [length]="installationsService.processedInstallations.length"
            [pageIndex]="param.pageIndex"
            [pageSize]="param.pageSize"
            [pageSizeOptions]="installationsService.pageSizes"
            (page)="page($event)"
          >
          </mat-paginator>
        </app-installation-list>

        <app-plant-overview-link [overviewUrl]="overviewUrl"></app-plant-overview-link>
      </ng-container>

      <ng-template #noData>
        <!-- Domain change - deletion recommended; view is accesible only by RSA who has no vkorg -->
        <ng-container
          *ngIf="
            isUserFromGermanyOrAustria &&
            (remoteConfigStore.isBannerVisible(advertisingBannerForDeAndAu) | async) &&
            (backendStorageStore.advertBannerVisibility$ | async)
          "
        >
          <div class="advert-banner flex flex-row">
            <img
              class="advert-banner__img lt-md:!hidden"
              src="assets/img/banner-advert-DE-AU.png"
            />

            <div class="flex flex-col advert-banner__wrapper">
              <div class="flex flex-row justify-between">
                <h2>
                  {{ '+INSTALLATIONS.NOTIFICATIONS.BANNER_ADVERT.TITLE' | translate }}
                </h2>
                <button
                  mat-icon-button
                  gtm="onOpen"
                  gtmAction="Banner"
                  gtmCategory="installationDashboard"
                  (click)="onAdvertBannerClose()"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>

              <div
                class="advert-banner__info"
                [innerHTML]="
                  '+INSTALLATIONS.NOTIFICATIONS.BANNER_ADVERT.INFO' | translate | viTrustHtml
                "
              ></div>

              <a
                class="advert-banner__link"
                mat-stroked-button
                rel="noreferrer"
                [href]="advertBannerLink"
                target="_blank"
              >
                <span>
                  {{ '+INSTALLATIONS.NOTIFICATIONS.BANNER_ADVERT.NAVIGATE' | translate }}
                </span>
                <mat-icon iconPositionEnd>arrow_forward</mat-icon>
              </a>
            </div>
          </div>
        </ng-container>

        <div
          class="vitoconnect-banner"
          *ngIf="remoteConfigStore.isBannerVisible(vitoconnectIssueBanner) | async"
        >
          <app-banner
            type="info"
            [title]="'+INSTALLATIONS.NOTIFICATIONS.BANNER.VITOCONNECT_TITLE' | translate"
            [linkLabel]="
              '+INSTALLATIONS.INSTALLATIONS.ANNOUNCEMENT_BANNER.MORE_INFORMATION' | translate
            "
            [link]="vitoconnectLink"
            linkGtm="onGoToPage"
          >
            {{ '+INSTALLATIONS.NOTIFICATIONS.BANNER.VITOCONNECT_INFO' | translate }}
          </app-banner>
        </div>

        <vi-info-panel data-at-no-data imageSrc="/assets/img/no-installation.png">
          <div content class="flex flex-col gap-[16px] justify-start items-start">
            <h2 data-at-title-no-data class="panel-item flex-auto">
              {{ '+INSTALLATIONS.INSTALLATIONS.CONNECTION.NO_CONNECTION_HEADER' | translate }}
            </h2>
            <div data-at-content-no-data class="panel-item flex-auto">
              {{ '+INSTALLATIONS.INSTALLATIONS.CONNECTION.NO_CONNECTION' | translate }}
            </div>
            <button
              mat-raised-button
              color="primary"
              data-at-btn-no-data
              *ngIf="dataService.invitationsCount$ | async"
              class="panel-item"
              gtm="onGoToPage"
              gtmAction="Invitations"
              gtmCategory="installationsOverview"
              [routerLink]="['/invitations']"
            >
              {{ '+INSTALLATIONS.INSTALLATIONS.CONNECTION.SEE_REQUESTS' | translate }} ({{
                dataService.invitationsCount$ | async
              }})
            </button>
          </div>
        </vi-info-panel>
      </ng-template>
    </ng-template>
  </vi-content>

  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>
